import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FullProposalModel, ProposerModel } from '../../models/proposer.model';
// @ts-ignore
import html2pdf from 'html2pdf.js';
import { environment } from 'src/environments/environment';
import { EventService } from 'src/app/core/services/event.service';
import { ProposalsService } from 'src/app/pages/proposals/services/proposals.service';
import { Deals } from 'src/app/pages/deals/models/deals.model';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { PropertiesService } from 'src/app/pages/properties/services/properties.services';

@Component({
  selector: 'app-proposal-template',
  templateUrl: './proposal-template.component.html',
  styleUrls: ['./proposal-template.component.scss']
})
export class ProposalTemplateComponent implements OnInit, AfterViewInit {

  itemsPage1: { i: number, sub: { name: string, fieldName: string, size: number, suffix?: string }[] }[] = [
    {
      i: 1,
      sub: [
        { name: 'Nome', fieldName: 'name', size: 70 },
        { name: 'NIF', fieldName: 'fiscalIdentification', size: 30 }
      ]
    },
    {
      i: 2,
      sub: [
        { name: 'Doc. Identificação', fieldName: 'docType', size: 35 },
        { name: 'N.º:', fieldName: 'docNumber', size: 35 },
        { name: 'Válido até', fieldName: 'docExpiration', size: 30 }
      ]
    },
    {
      i: 3,
      sub: [
        { name: 'Estado Civil', fieldName: 'maritalStatus', size: 25 },
        { name: 'Regime Bens', fieldName: 'propertyRegime', size: 35 },
        { name: 'Naturalidade', fieldName: 'naturalness', size: 40 }
      ]
    },
    {
      i: 4,
      sub: [
        { name: 'Nacionalidade(s)', fieldName: 'nationality', size: 35 },
        { name: 'Email', fieldName: 'email', size: 35 },
        { name: 'Telefone', fieldName: 'phone', size: 30 }
      ]
    },
    {
      i: 5,
      sub: [
        { name: 'Morada Permanente', fieldName: 'address', size: 100 }
      ]
    },
    {
      i: 6,
      sub: [
        { name: 'Localidade', fieldName: 'city', size: 40 },
        { name: 'Código Postal', fieldName: 'postalCode', size: 35 },
        { name: 'País', fieldName: 'country', size: 25 }
      ]
    },
    {
      i: 7,
      sub: [
        { name: 'Morada Fiscal', fieldName: 'fiscalAddress', size: 100 }
      ]
    },
    {
      i: 8,
      sub: [
        { name: 'Localidade', fieldName: 'fiscalCity', size: 40 },
        { name: 'Código Postal', fieldName: 'fiscalPostalCode', size: 35 },
        { name: 'País', fieldName: 'fiscalCountry', size: 25 }
      ]
    },
    {
      i: 9,
      sub: [
        { name: 'Profissão', fieldName: 'occupation', size: 30 },
        { name: 'Entidade Empregadora', fieldName: 'employer', size: 70 }
      ]
    }
  ];
  coletiveItems: { i: number, sub: { name: string, fieldName: string, size: number, suffix?: string }[] }[] = [
    {
      i: 1,
      sub: [
        { name: 'Firma', fieldName: 'company', size: 70 },
        { name: 'NIPC', fieldName: 'companyFiscalIdentification', size: 30 },
        { name: 'Certidão Permanente do Registo Comercial', fieldName: 'permanentRegistry', size: 100 }
      ]
    },
  ]
  itemsPage2: { i: number, sub: { name: string, fieldName: string, size: number, suffix?: string }[] }[] = [
    {
      i: 1,
      sub: [
        { name: 'Valor da Proposta €', fieldName: 'proposalValue', size: 50 },
        { name: 'Banco', fieldName: 'bank', size: 30 },
        { name: 'Financiamento', fieldName: 'financing', size: 20, suffix: '%' },
      ]
    },
    {
      i: 2,
      sub: [
        { name: 'Proveniência de Fundos', fieldName: 'sourceFunds', size: 100 }
      ]
    },
    {
      i: 3,
      sub: [
        { name: 'Prazo para assinatura do CPCV (dias)', fieldName: 'promiseContractTime', size: 50 },
        { name: 'Sinal CPCV', fieldName: 'signalBooster', size: 25 },
        { name: 'Prazo Escritura', fieldName: 'deedTime', size: 25 }
      ]
    },
    {
      i: 31,
      sub: [
        { name: '2.º Sinal', fieldName: 'signalBooster2', size: 35 },
        { name: '3.º Sinal', fieldName: 'signalBooster3', size: 30 },
        { name: '4.º Sinal', fieldName: 'signalBooster4', size: 35 }
      ]
    },
    {
      i: 4,
      sub: [
        { name: 'Finalidade e natureza pretendida da relação de negócio', fieldName: 'purpose', size: 100 },
      ]
    },
    {
      i: 5,
      sub: [
        { name: 'Valor Reserva €', fieldName: 'reserveValue', size: 40 },
        { name: 'Meio Pagamento', fieldName: 'paymentMethod', size: 60 }
      ]
    },
  ];
  itemsPage2Rent: { i: number, sub: { name: string, fieldName: string, size: number, suffix?: string }[] }[] = [
    {
      i: 1,
      sub: [
        { name: 'Valor da Proposta €', fieldName: 'proposalValue', size: 50 },
        { name: 'Data de Início', fieldName: 'startDate', size: 30 },
        { name: 'Caução', fieldName: 'securityDeposit', size: 20 },
      ]
    },
    {
      i: 2,
      sub: [
        { name: 'Duração Contrato', fieldName: 'contractDuration', size: 50 },
        { name: ' Duração das Renovações', fieldName: 'renewalDuration', size: 50 },
      ]
    },
    {
      i: 3,
      sub: [
        { name: 'Finalidade e natureza pretendida da relação de negócio', fieldName: 'purpose', size: 100 },
      ]
    },
    {
      i: 4,
      sub: [
        { name: 'Valor Reserva €', fieldName: 'reserveValue', size: 40 },
        { name: 'Meio Pagamento', fieldName: 'paymentMethod', size: 60 }
      ]
    },
  ];
  @Input() proposalData!: FullProposalModel;
  @Input() deal!: Deals;
  @Input() leadId: any;
  @Input() entityData: any;
  @Input() isEdit: boolean = false;
  @Input() proposal: any;
  proposersCount: number = 0;
  pagesCount: number = 2;
  logoPath = `${environment.apiUrl}/${environment.dirLogoImage}/`;
  selectData: { [key: string]: { key: any, text: string }[] } = {
    purpose: [
      { key: 'PERMANENT', text: 'Habitação Permanente' },
      { key: 'SECONDARY', text: 'Habitação Secundária' },
      { key: 'INVESTMENT', text: 'Investimento' }
    ],
    paymentMethod: [
      { key: 'CASH', text: 'Numerário' },
      { key: 'CHECK_REAL', text: 'Cheque à ordem Imobiliária' },
      { key: 'CHECK_OWNER', text: 'Cheque à ordem Proprietário' },
      { key: 'TRANSFER_REAL', text: 'Transferência Bancária Imobiliária' },
      { key: 'TRANSFER_OWNER', text: 'Transferência Bancária Proprietário' }
    ],
    type: [
      { key: 'INDIVIDUAL', text: 'Pessoa Singular' },
      { key: 'LEGAL', text: 'Pessoa Coletiva' },
      { key: 'EFFECTIVE_BENEFICIARY', text: 'Beneficiário Efetivo' },
      { key: 'FIATHER', text: 'Fiador' } // Deve ser controlado via *ngIf
    ],
    docType: [
      { key: 'CITIZEN_CARD', text: 'Cartão Cidadão' },
      { key: 'ID_CARD', text: 'Bilhete de Identidade' },
      { key: 'RESIDENCE', text: 'Título de Residência' },
      { key: 'PASSPORT', text: 'Passaporte' }
    ],
    propertyRegime: [
      { key: 'COMMUNION_ACQUIRED', text: 'Adquiridos' },
      { key: 'COMMUNION_GENERAL', text: 'Geral' },
      { key: 'SEPARATION', text: 'Separação' }
    ],
    actionType: [
      { key: 'SELF', text: 'Conta Própria' },
      { key: 'OTHER', text: 'Conta de Outrem' }
    ],
    maritalStatus: [
      { key: 'SINGLE', text: 'Solteiro(a)' },
      { key: 'MARRIED', text: 'Casado(a)' },
      { key: 'DIVORCED', text: 'Divorciado(a)' },
      { key: 'WIDOWED', text: 'Viúvo(a)' },
      { key: 'SEPARATED', text: 'Separado(a)' }
    ]
  };

  constructor(
    private eventService: EventService,
    private proposalService: ProposalsService,
    private translateService: TranslateService,
    private propertiesService: PropertiesService,
  ) { }

  get isSaleBusinessType(): boolean {
    return this.resolveProposalBusinessType() === 'SALE';
  }

  get isRentBusinessType(): boolean {
    return this.resolveProposalBusinessType() === 'RENT';
  }

  ngOnInit(): void {
    this.proposersCount = this.proposalData.proposers.length;
  }

  ngAfterViewInit(): void {
    this.generatePdf();
  }

  getItemByFieldName(field: string, proposer: ProposerModel, suffix: any = null) {
    const fieldName = field as keyof ProposerModel;
    if (this.getTextByKey(field, proposer[fieldName])) {
      return this.getTextByKey(field, proposer[fieldName])
    } else {
      if (suffix) {
        return proposer[fieldName] ? proposer[fieldName] + suffix : '';
      } else {
        return proposer[fieldName] ? proposer[fieldName] : '';
      }
    }
  }

  private readonly signalPercentFlagByField: any = {
    signalBooster: 'signalBoosterPercent',
    signalBooster2: 'signalBooster2Percent',
    signalBooster3: 'signalBooster3Percent',
    signalBooster4: 'signalBooster4Percent',
  };

  getProposalItemByFieldName(field: any, proposal: FullProposalModel, suffix: any = null) {
    const percentFlag = this.signalPercentFlagByField[field];
    if (percentFlag) {
      const value = (proposal as any)?.[field];
      if (value === null || value === undefined || value === '' || Number(value) === 0) {
        return '';
      }
      const isPercent =
        (proposal as any)?.[percentFlag] === true ||
        `${(proposal as any)?.[percentFlag]}` === 'true';
      return isPercent ? `${value}%` : `${value} €`;
    }
    const fieldName = field as keyof FullProposalModel;
    if (this.getTextByKey(field, proposal[fieldName])) {
      return this.getTextByKey(field, proposal[fieldName])
    } else {
      if (suffix) {
        return proposal[fieldName] ? proposal[fieldName] + suffix : '';
      } else {
        return proposal[fieldName] ? proposal[fieldName] : '';
      }
    }
  }

  generatePdf() {
    if (!this.isEdit) {
      const pendingProposalsLimit = Number(
        this.entityData?.pendingProposalsLimit ?? this.entityData?.pendingProposals ?? 0,
      );
      const propertyId = this.deal?.property?.id ?? this.proposal?.property?.id;

      if (pendingProposalsLimit > 0 && propertyId) {
        this.propertiesService.findOne(propertyId).subscribe({
          next: (propertyData) => {
            const proposals = propertyData?.proposals ?? [];
            const activeProposals = this.getActiveProposalsCount(proposals);

            if (activeProposals >= pendingProposalsLimit) {
              this.eventService.broadcast('proposal-pdf-generated');
              this.showProposalLimitError();
              return;
            }

            this.generatePdfFile();
          },
          error: () => {
            this.eventService.broadcast('proposal-pdf-generated');
            Swal.fire(this.translateService.instant('t-error-creating'), '', 'error');
          },
        });
        return;
      }
    }

    this.generatePdfFile();
  }

  private generatePdfFile() {
    setTimeout(() => {
      this.pagesCount = document.querySelectorAll('.pdf-page').length;
      const element = document.getElementById('proposal-template');
      const opt = {
        margin: [10, 10, 10, 10],
        filename: `proposta-${this.deal.property?.ref}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2, useCORS: true,
          allowTaint: false,
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      };
      html2pdf()
        .from(element)
        .set(opt)
        .outputPdf('blob')
        .then((pdfBlob: any) => {
          element?.classList.add('d-none');
          const formData = new FormData();
          formData.append('file', pdfBlob, `proposta-${this.deal.property?.ref}.pdf`);
          formData.append('value', this.proposalData.proposalValue);
          if (this.leadId !== null && this.leadId !== undefined && `${this.leadId}` !== '') {
            formData.append('lead', `${this.leadId}`);
          }
          const date: any = new Date();
          formData.append('proposalDate', date);
          if (this.deal?.property?.id)
            formData.append('propertyId', this.deal?.property?.id);

          Object.keys(this.proposalData).forEach(key => {
            const k = key as keyof FullProposalModel;
            if (
              this.proposalData[k] !== null &&
              this.proposalData[k] !== undefined &&
              this.proposalData[k] !== '' &&
              !['proposalValue', 'proposers'].includes(k)
            ) {
              formData.append(k, this.proposalData[k]);
            } else if (k === 'proposers') {
              formData.append(k, JSON.stringify(this.proposalData[k]));
            }
          });
          if (this.isEdit) {
            this.proposalService.updateProposal(formData, this.proposal?.proposal?.id).subscribe({
              next: () => {
                const url = URL.createObjectURL(pdfBlob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `proposta-${this.deal.property?.ref}.pdf`;
                a.click();
                URL.revokeObjectURL(url);
                this.eventService.broadcast('proposal-pdf-generated');
                Swal.fire({
                  //position: 'top-end',
                  icon: 'success',
                  title: "Proposta atualizada com sucesso",
                  showConfirmButton: false,
                  timer: 1500,
                });
              },
              error: () => {
                this.eventService.broadcast('proposal-pdf-generated');
                Swal.fire("Erro ao atualizar a proposta", "", "error");
              }
            });
          } else {
            this.proposalService.createProposal(formData).subscribe({
              next: () => {
                const url = URL.createObjectURL(pdfBlob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `proposta-${this.deal.property?.ref}.pdf`;
                a.click();
                URL.revokeObjectURL(url);
                this.eventService.broadcast('proposal-pdf-generated');
                Swal.fire({
                  //position: 'top-end',
                  icon: 'success',
                  title: "Proposta criada com sucesso",
                  showConfirmButton: false,
                  timer: 1500,
                });
              },
              error: (err) => {
                this.eventService.broadcast('proposal-pdf-generated');
                if (this.isPendingProposalLimitError(err)) {
                  this.showProposalLimitError();
                  return;
                }
                Swal.fire(this.getTranslatedErrorMessage(err) ?? "Erro ao criar proposta", "", "error");
              }
            });
          }
        });
    }, 0);
  }

  // O exception filter global aninha as respostas de HttpException:
  // { message: { statusCode, message: '<chave i18n>', error } }. Quando a
  // mensagem é uma chave t-... com tradução (ex.: proposta em aberto para o
  // mesmo imóvel), mostra-a em vez do erro genérico.
  private getTranslatedErrorMessage(error: any): string | null {
    const messagePayload = error?.error?.message;
    const messageKey =
      typeof messagePayload === 'string' ? messagePayload : messagePayload?.message;
    if (typeof messageKey !== 'string' || !messageKey.startsWith('t-')) {
      return null;
    }
    const translated = this.translateService.instant(messageKey);
    return translated && translated !== messageKey ? translated : null;
  }

  private getActiveProposalsCount(proposals: any[]) {
    return (proposals ?? []).filter(
      (proposal) => !this.isCancelledProposal(proposal),
    ).length;
  }

  private isCancelledProposal(proposal: any) {
    const status = this.getCurrentProposalStatus(proposal);
    return ['declined', 'canceled', 'cancelled', 'recusad', 'cancelad'].some(
      (value) => status.includes(value),
    );
  }

  private getCurrentProposalStatus(proposal: any) {
    return String(
      proposal?.lastAction?.originalStatus ??
      proposal?.history?.[0]?.originalStatus ??
      proposal?.lastAction?.proposalStatus ??
      proposal?.history?.[0]?.proposalStatus ??
      '',
    ).toLowerCase();
  }

  private showProposalLimitError() {
    Swal.fire({
      title: this.getLimitReachedMessage(),
      text: '',
      icon: 'info',
      confirmButtonColor: 'rgb(54, 69, 116)',
      confirmButtonText: this.translateService.instant('t-close'),
    });
  }

  private getLimitReachedMessage() {
    const translateKey = 't-pending-proposals-limit-reached';
    const message = this.translateService.instant(translateKey);
    return message !== translateKey
      ? message
      : this.translateService.instant('t-pending-proposals-limit-reached-fallback');
  }

  private isPendingProposalLimitError(error: any): boolean {
    const messages = this.extractErrorMessages(error);
    return messages.some((message) => {
      const normalized = String(message ?? '').trim();
      return normalized === 'Property does not accept more proposals'
        || normalized.includes('Property does not accept more proposals');
    });
  }

  private extractErrorMessages(error: any): string[] {
    if (error === null || error === undefined) return [];

    if (typeof error === 'string') {
      return [error];
    }

    if (Array.isArray(error)) {
      return error.flatMap((item) => this.extractErrorMessages(item));
    }

    if (typeof error === 'object') {
      if ('message' in error) {
        return this.extractErrorMessages((error as any).message);
      }
      if ('error' in error) {
        return this.extractErrorMessages((error as any).error);
      }
    }

    return [String(error)];
  }

  getTextByKey(field: keyof typeof this.selectData, value: string | number): string | null | undefined {
    if (this.selectData[field])
      return this.selectData[field].find((option: any) => option.key === value)?.text;

    return null;
  }

  private resolveProposalBusinessType(): 'SALE' | 'RENT' {
    const property = this.deal?.property ?? this.proposal?.property ?? {};
    const normalizedFromText = this.normalizeBusinessType(
      property?.businessType ??
      property?.propertyBusinessType?.description ??
      property?.businessTypeData?.description,
    );

    if (normalizedFromText) {
      return normalizedFromText;
    }

    const businessTypeId = Number(
      property?.businessType ??
      property?.propertyBusinessTypeId ??
      property?.propertyBusinessType?.id ??
      property?.businessTypeData?.id,
    );
    const rentTypeId = Number(property?.typeRent);
    if (
      Number.isFinite(businessTypeId) &&
      businessTypeId > 0 &&
      Number.isFinite(rentTypeId) &&
      rentTypeId > 0
    ) {
      return businessTypeId === rentTypeId ? 'RENT' : 'SALE';
    }

    return 'SALE';
  }

  private normalizeBusinessType(value: any): 'SALE' | 'RENT' | null {
    if (value === null || value === undefined) {
      return null;
    }

    const normalizedValue = `${value}`.trim().toUpperCase();
    if (!normalizedValue) {
      return null;
    }

    if (
      normalizedValue.includes('SALE') ||
      normalizedValue.includes('SELL') ||
      normalizedValue.includes('VENDA')
    ) {
      return 'SALE';
    }

    if (
      normalizedValue.includes('RENT') ||
      normalizedValue.includes('LEASE') ||
      normalizedValue.includes('ARREND')
    ) {
      return 'RENT';
    }

    return null;
  }

}
